import React from 'react'

import { Divider, Table, Row, Col, Button } from '_zari/core'

import * as FormGroups from './formGroups'

const ReparticionesCuentasSection = ({ reparticiones, dispatch }) => {
  const [cuentaDebe, setCuentaDebe] = React.useState('')
  const [nombreCuentaDebe, setNombreCuentaDebe] = React.useState('')
  const [cuentaHaber, setCuentaHaber] = React.useState('')
  const [nombreCuentaHaber, setNombreCuentaHaber] = React.useState('')
  const [porcentaje, setPorcentaje] = React.useState('')

  const onCreate = React.useCallback(() => {
    dispatch({
      type: 'agregar',
      payload: {
        cuentaDebe,
        cuentaHaber,
        porcentaje
      }
    })

    setCuentaDebe('')
    setNombreCuentaDebe('')
    setCuentaHaber('')
    setNombreCuentaHaber('')
    setPorcentaje('')
  }, [dispatch, cuentaDebe, cuentaHaber, porcentaje])

  const onClickEliminar = React.useCallback(
    _idFila => {
      dispatch({
        type: 'eliminar',
        payload: { _idFila }
      })
    },
    [dispatch]
  )

  const onChangeCuentaDebe = React.useCallback(input => {
    setCuentaDebe(input.value)
    setNombreCuentaDebe(input.label)
  }, [])

  const clickClearDebe = React.useCallback(() => {
    setCuentaDebe('')
    setNombreCuentaDebe('')
  }, [])

  const onChangeCuentaHaber = React.useCallback(input => {
    setCuentaHaber(input.value)
    setNombreCuentaHaber(input.label)
  }, [])

  const clickClearHaber = React.useCallback(() => {
    setCuentaHaber('')
    setNombreCuentaHaber('')
  }, [])

  return (
    <>
      <Divider />
      <Row>
        <Col md={5}>
          <Table
            filas={reparticiones}
            headRows={[{ label: 'DEBE' }, { label: 'HABER' }, { label: 'PORC %' }, { label: '' }]}
            maxRowsShown={4}
            rowTemplate={(row, k) => (
              <Table.Row key={k}>
                <Table.Cell>{row.cuentaDebe || '--'}</Table.Cell>
                <Table.Cell>{row.cuentaHaber || '--'}</Table.Cell>
                <Table.Cell>{row.porcentaje || '--'}</Table.Cell>
                <Table.Cell>
                  <Button onClick={() => onClickEliminar(row._idFila)} color='danger'>
                    X
                  </Button>
                </Table.Cell>
              </Table.Row>
            )}
          />
        </Col>
        <Col md={7}>
          <FormGroups.CuentaDebeFormGroup value={cuentaDebe} nameValue={nombreCuentaDebe} onChange={onChangeCuentaDebe} clickClear={clickClearDebe} />
          <FormGroups.CuentaHaberFormGroup
            value={cuentaHaber}
            nameValue={nombreCuentaHaber}
            onChange={onChangeCuentaHaber}
            clickClear={clickClearHaber}
          />
          <FormGroups.PorcentajeFormGroup value={porcentaje} onChange={e => setPorcentaje(e.target.value)} />
          <Row>
            <Col md={12} className='text-right'>
              <Button onClick={onCreate}>Agregar</Button>
            </Col>
          </Row>
        </Col>
      </Row>
      <Divider />
    </>
  )
}

export default React.memo(ReparticionesCuentasSection)
